<template>
  <div id="ecommerce-app">
    <ecommerce-header />
    <main class="main-content">
      <Home />
    </main>
    <ecommerce-cart-sidebar />
    <ecommerce-otp-modal />
    <ecommerce-footer />
  </div>
</template>

<script>
import EcommerceHeader from './ecommerce/components/common/AppHeader.vue';
import EcommerceFooter from './ecommerce/components/common/AppFooter.vue';
import EcommerceCartSidebar from './ecommerce/components/common/CartSidebar.vue';
import EcommerceOtpModal from './ecommerce/components/common/OTPModal.vue';
import Home from './ecommerce/views/Home.vue';

export default {
  name: "WebsiteB2C",
  components: {
    EcommerceHeader,
    EcommerceFooter,
    EcommerceCartSidebar,
    EcommerceOtpModal,
    Home,
  }
};
</script>

<style scoped>
.main-content {
  min-height: calc(100vh - 120px);
}
</style>

<style>
/* Global styles for e-commerce */
.ecommerce-app * {
  box-sizing: border-box;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}
</style>